import { DataPointWithValue } from '@src/types/DataPoint';
import { ReactElement } from 'react';

interface UnitProps {
  label: string;
  dataPoints: DataPointWithValue[];
  rectangleXCoordinate: string;
  rectangleYCoordinate: string;
  textStartingXCoordinate: number;
  textStartingYCoordinate: number;
  lineTransformXCoordinate?: number;
  lineTransformYCoordinate?: number;
  skipHorizontalLine?: boolean;
}

type TextCoordinates = {
  yCoordinate: number;
};

function Unit(props: UnitProps): ReactElement {
  const {
    label,
    dataPoints,
    rectangleXCoordinate,
    rectangleYCoordinate,
    textStartingXCoordinate,
    textStartingYCoordinate,
  } = props;

  const getTextCoordinates = (rowIndex: number): TextCoordinates => {
    const verticalSpace = 10;
    const verticalOffset = verticalSpace * rowIndex;

    return {
      yCoordinate: textStartingYCoordinate + verticalOffset,
    };
  };

  const textProps = {
    fill: 'black',
    stroke: 'none',
    fontSize: '5px',
  };

  const getDataPointValue = (pointAlias: string) => {
    const filteredItem = dataPoints.filter(
      (point) => point.pointAlias === pointAlias,
    );

    return filteredItem.length > 0 ? filteredItem[0].value : '';
  };

  return (
    <>
      <rect
        x={rectangleXCoordinate}
        y={rectangleYCoordinate}
        width='65'
        height='75'
        fill='white'
      />

      <text
        fontWeight='bold'
        x={textStartingXCoordinate}
        y={getTextCoordinates(1).yCoordinate}
        {...textProps}
      >
        {label}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(2).yCoordinate}
        {...textProps}
      >
        Racks Online: {getDataPointValue('unitController_racksonline')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(3).yCoordinate}
        {...textProps}
      >
        kW: {getDataPointValue('kw')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(4).yCoordinate}
        {...textProps}
      >
        kVAR: {getDataPointValue('kvar')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(5).yCoordinate}
        {...textProps}
      >
        SOC: {getDataPointValue('unitController_SOC_float')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(6).yCoordinate}
        {...textProps}
      >
        Inv Status: {getDataPointValue('unitController_InvStatus_string')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(7).yCoordinate}
        {...textProps}
      >
        Run Mode: {getDataPointValue('unitController_RunMode_string')}
      </text>
    </>
  );
}

export default Unit;
